export interface RegimeDrift {
  readonly axis: string;
  readonly rate: number;
}

export interface RegimeTransitionSnapshot {
  readonly regime: string;
  readonly margin: number;
  readonly drift: readonly RegimeDrift[];
}

export type RegimeTransitionStatus = "green" | "yellow" | "red";

export const CURRENT_REGIME_TRANSITION: RegimeTransitionSnapshot = {
  regime: "R1",
  margin: 0.847,
  drift: [
    { axis: "G1 (Authority)", rate: -0.002 },
    { axis: "G2 (Knowledge)", rate: -0.005 },
    { axis: "G3 (Temporal)", rate: -0.001 },
    { axis: "G4 (Resource)", rate: 0.0 },
  ],
};

export function worstRegimeDrift(snapshot: RegimeTransitionSnapshot): RegimeDrift {
  return snapshot.drift.reduce((worst, drift) => (worst.rate < drift.rate ? worst : drift));
}

export function regimeTransitionStatus(margin: number): RegimeTransitionStatus {
  if (margin > 0.5) return "green";
  if (margin > 0.1) return "yellow";
  return "red";
}

export function deploymentsToBoundary(snapshot: RegimeTransitionSnapshot): number {
  const worstDrift = worstRegimeDrift(snapshot);
  return snapshot.margin / Math.abs(worstDrift.rate + 1e-15);
}

export function driftColor(rate: number): string {
  if (rate < -0.003) return "#f87171";
  if (rate < 0) return "#fbbf24";
  return "#34d399";
}
